import { render, staticRenderFns } from "./VienasNamuose.vue?vue&type=template&id=5d1fcca2&"
import script from "./VienasNamuose.vue?vue&type=script&lang=js&"
export * from "./VienasNamuose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports